export const translations = {
  en: {
    common: {
      language: "Language",
      english: "English",
      indonesian: "Indonesia",
      loading: "Loading...",
      fullName: "Full Name",
      email: "Email Address",
      role: "Account Role",
      saveChanges: "Save Changes",
      cancel: "Cancel",
      logout: "Logout",
      editProfile: "Edit Profile",
      username: "Username",
      optional: "Optional",
      name : "Full Name",
      close: "Close",
      error: "Something went wrong",
      area: "Area",
      allAreas: "All areas",
      unassigned: "Unassigned"
    },
    login: {
      createAccount: "Create Account",
      registerAsWorker: "Register as a worker",
      signUp: "Sign Up",
      signingUp: "Signing Up...",
      signIn: "Sign In",
      signingIn: "Signing In...",
      systemName: "Cleaning Service Performance Rating System",
      needAccount: "Need an account? Sign Up",
      haveAccount: "Already have an account? Sign In",
      welcomeBack: "Welcome Back!",
      haveAccountOverlay: "Already have an account? Sign in with your credentials.",
      helloWorker: "Hello, Worker!",
      noAccountOverlay: "Don't have an account? Register and join your team!",
      registrationSuccess: "Registration successful! Waiting for admin approval...",
      loginFailed: "Login failed",
      registrationFailed: "Registration failed",
      password: "Password",
      emailOrUsername: "Email or Username",
    },
    schedule: {
      title: "Work Schedule",
      subtitle: "Daily cleaning schedule by area",
      myArea: "My Area",
      myAreaBadge: "Your area",
      wholeSchedule: "Whole Schedule",
      filterLabel: "Schedule filter",
      sections: "Sections",
      now: "Now",
      expand: "Expand",
      closeExpanded: "Close",
      noAreaAssigned: "You haven't been assigned an area yet, so the whole schedule is shown.",
      empty: "No schedule available for this area.",
      note: "Tasks are not binding. If other work is needed, adjust as directed by the supervisor and with the knowledge of PJP & FM."
    },
    profile: {
      title: "My Profile",
      subtitle: "View and manage your account settings",
      accountInfo: "Account Information",
      statistics: "Statistics",
      preferences: "Preferences",
      accountCreated: "Account Created",
      avgRating: "Average Rating",
      totalRatingsReceived: "Total Ratings Received",
      totalRatingsGiven: "Total Ratings Given",
      totalRatings: "Total Ratings",
      accountId: "Account ID",
      notAvailable: "Not available",
      receiveEmail: "Receive email notifications",
      receiveEmailWorkerDesc: "Get notified about ratings, feedback, and updates",
      receiveEmailSupervisorDesc: "Get notified about worker updates and system alerts",
      showTipsWorker: "Show dashboard tips",
      showTipsSupervisor: "Show tips and suggestions",
      showTipsWorkerDesc: "Display helpful tips on the worker dashboard",
      showTipsSupervisorDesc: "Display helpful tips when using the dashboard",
      showTipsAdmin: "Show admin dashboard tips",
      updatedSuccess: "Profile updated successfully.",
      updateFailed: "Failed to update profile.",
      logoutTitle: "Logout",
      logoutConfirm: "Are you sure you want to logout?",
      changePhoto:"Change profile picture",
      fileTooLarge : "File too large!",
      invalidFileType: "Invalid file type. Please upload an image.",
      pictureUpdatedSuccess: "Profile picture updated successfully.",
      pictureUploadFailed: "Failed to upload profile picture."
    },
    workerHome: {
      loading: "Loading...",
      title: "Dashboard",
      welcomeBack: "Welcome back,",
      avgRating: "Average Rating",
      totalReviews: "Total Reviews",
      updated7Days: "Updated in Last 7 Days",
      recentRatings: "Recent Ratings Received",
      supervisor: "Supervisor",
      peer: "Peer",
      teamLead: "Team Lead",
      anonymousColleague: "Anonymous Colleague",
      supervisorRating: "Supervisor rating",
      peerRating: "Peer rating",
      noRatings: "No ratings yet. Check back soon for feedback from supervisors.",
      totalRatings: "Total Ratings",
      needsAttention: "Needs Attention",
      legendTitle: "Rating Field Abbreviations",
      hide: "Hide",
      show: "Show",
      monthlyHistory: "Monthly Rating History", 
      ratingsSuffix: "ratings",
      ratingSuffix: "rating",
      overallRating: "Overall Rating",
      cumulativeRanking: "Cumulative Ranking",
      notRanked: "Not ranked",
      noMonthlyHistory: "No monthly history available yet.",
      avgShort: "avg",
      overview: "Your Performance Overview"
    },
    workerRatings: {
      modalTitle: "Request Rating Edit",
      modalReasonLabel: "Why do you need to edit this rating?",
      modalReasonPlaceholder: "Provide a reason for your edit request...",
      lateSubmissionModalTitle: "Request Late Submission Permission",
      lateSubmissionReasonLabel: "Why do you need to request late submission permission?",
      lateSubmissionReasonPlaceholder: "Provide a reason for your late submission request...",
      submitting: "Submitting...",
      submitRequest: "Submit Request",
      rateColleaguesTitle: "Rate Colleagues",
      rateColleaguesSubtitle: "Rate colleagues for completed months only",
      byMonth: "By month",
      apply: "Apply",
      visibleWorkers: "Visible Workers",
      ratedByYou: "Rated by You",
      notYetRated: "Not Yet Rated",
      searchByName: "Search by name...",
      all: "All",
      rated: "Rated",
      unrated: "Unrated",
      ratingMonth: "Rating Month",
      ratingUnavailable: "Rating unavailable for",
      workersCanOnlyRate: "Workers can only rate in",
      loadingWorkers: "Loading workers...",
      noWorkersSearch: "No workers found matching your search.",
      noWorkersDisplay: "No workers to display.",
      tableName: "Name",
      tableAvgRating: "Avg Rating",
      tableLatestRating: "Latest Rating",
      tableSelectedMonth: "Selected Month",
      tableLastComment: "Last Comment",
      avgShort: "avg",
      lowShort: "low",
      selectedMonthTag: "selected month",
      noRatingsYet: "No ratings yet",
      action: "Action",
      editPending: "Edit Pending",
      edit: "Edit",
      requestEdit: "Request Edit",
      rate: "Rate",
      askAdminUnlock: "Ask admin to unlock this rating for editing",
      dash: "-",
      tableIndex: "No.",
      pendingApproval: "Pending Approval",
      requestPermission: "Request Permission",
      activeFilterMonthPrefix: "Month:",
      clearFilter: "Clear filter",
      myAverageRating: "My Average Rating This Month",    
      legendTitle: "Status:",
      myCumulativeRating: "My Cumulative Rating",
      sessions: "Sessions",
      latestRating: "Last Rating Date",
      myRatingThisMonth: "My Rating This Period"
    },
    ratingForm: {
      commentLabel: "Comments (Optional)",
      commentPlaceholder: "Add feedback or comments...",
      submitting: "Submitting...",
      updating: "Updating...",
      submit: "Submit Rating",
      update: "Update Rating",
      rateTitle: "Rate",
      overallAverage: "Average rating",
      editTitle: "Edit Rating"
    },
    workerFeedback: {
      title: "Feedback",
      subtitle: "Feedback from supervisors and colleagues",
      byMonth: "By month",
      apply: "Apply",
      loadingFeedback: "Loading feedback...",
      supervisorFeedback: "Supervisor Feedback",
      peerFeedback: "Peer Feedback",
      noSupervisorFeedback: "No supervisor feedback with comments yet.",
      noPeerFeedback: "No peer feedback with comments yet.",
      anonymousColleague: "Anonymous Colleague",
      supervisorLabel: "Supervisor Feedback",
      peerLabel: "Peer Feedback",
      ratingMonth: "Feedback Period",
      allTime: "All time",
      legendTitle: "Rating colors:",
      noRatings: "No ratings yet",
      excellent: "Excellent (≥ 3.51)",
      good: "Good (2.76 - 3.50)",
      average: "Average (2.00 - 2.75)",
      needsImprovement: "Needs Improvement (< 2.00)"
    },
    workerNav: {
      home: "Home",
      rateColleagues: "Rate Colleagues",
      feedback: "Feedback",
      profile: "Profile",
      logout: "Logout",
      expand: "Expand",
      collapse: "Collapse",
      schedule: "Work Schedule"
    },
    supervisorNav: {
      home: "Home",
      details: "Rate Worker",
      dataVisuals: "Data Visuals",
      profile: "Profile",
      logout: "Logout",
      expand: "Expand",
      collapse: "Collapse",
      schedule: "Work Schedule"
    },
    supervisorHome: {
      loading: "Loading...",
      welcomeBack: "Welcome Back!",
      overview: "Here is your performance overview",
      totalWorkers: "Total Workers",
      averageRating: "Average Rating",
      topPerformer: "Top Performer",
      filterThisMonth: "This Month",
      filterCumulative: "Cumulative",
      belowTwoTitle: "Workers below 2.0",
      belowTwoLastMonth: "2.0 Last Month",
      seeDetails: "See details",
      noWorkersBelowTwo: "No workers below 2.0 right now.",
      recentRatings: "Recent Ratings",
      noRatings: "No ratings yet. Start rating workers to see recent activity.",
      workersRated: "Workers Rated",
      workersNotRated: "Workers Not Rated",
      updated7Days: "Updated in Last 7 Days",
      belowThree: "Below 3.0 Average",
      legendTitle: "Rating Field Abbreviations",
      hide: "Hide",
      show: "Show",
      notAvailable: "N/A",
      highest: "Highest",
      average: "Average",
      weakest: "Weakest",
      lowRatingHistory: "Months below 2.0",
      filterLastMonth: "Last Month",
      overviewMonth: "Here is your performance overview for",
      overviewCumulative: "Here is your cumulative performance overview."
    },
    supervisorRatings: {
      title: "Worker Details and Ratings",
      subtitle: "Rate workers for completed month only",
      byMonth: "By month",
      apply: "Apply",
      visibleWorkers: "Total CS",
      ratedInMonth: "Rated in Month",
      notYetRated: "Not Yet Rated",
      searchPlaceholder: "Search by name or email...",
      sort: "Sort",
      sortName: "Name (A-Z)",
      sortRating: "Highest Rating",
      sortRecent: "Latest Activity",
      all: "All",
      rated: "Rated",
      unrated: "Unrated",
      viewingMonth: "Viewing Month",
      ratingUnavailable: "Rating unavailable for",
      onlyAvailableIn: "Rating is only available in",
      loadingWorkers: "Loading workers...",
      noWorkersSearch: "No workers found matching your search.",
      noWorkersDisplay: "No workers to display.",
      name: "Name",
      email: "Email",
      sessions: "Sessions",
      status: "Status",
      latestRating: "Latest Rating",
      selectedMonth: "Selected Month",
      lastComment: "Last Comment",
      selectedMonthTag: "selected month",
      noRatingsYet: "No ratings yet",
      action: "Action",
      edit: "Edit",
      rate: "Rate",
      dash: "-",
      avgShort: "avg",
      lowShort: "low",
      avgRating: "Cumulative Average",       
      statusCumulative: "Cumulative Status",
      periodActive: "Active Period",
      detail : "Detail",
      myRatingThisMonth: "Rating This Month",
      legendTitle : "Status :",
      myAverageRating: "My Average Rating This Month"
    },
    supervisorVisuals: {
      loading: "Loading analytics...",
      title: "Data Visuals and Analytics",
      subtitle: "Performance metrics and insights",
      byMonth: "By month",
      apply: "Apply",
      filterNote: "Showing workers whose latest rating month matches the selected month.",
      overallAverage: "Overall Average Rating",
      basedOnWorkers: "Based on {count} workers",
      totalWorkersEvaluated: "Total Workers Evaluated",
      activeInSystem: "Active in system",
      excellentPerformers: "Excellent Performers",
      ratingThreeFour: "Rating 3.5+",
      noDataFilter: "No data matches the selected filter.",
      ratingDistribution: "Rating Distribution",
      pieTitle: "Rating Distribution Pie",
      workers: "workers",
      topPerformers: "Top 6 Performers",
      ratings: "ratings",
      kpiAverages: "Performance KPI Averages",
      kpiNote: "Based on workers with submitted monthly ratings: {count}",
      excellentLabel: "Excellent (3.51-4.00)",
      goodLabel: "Good (2.76-3.50)",
      averageLabel: "Average (2.0-2.75)",
      poorLabel: "Poor (<2.0)",
      notRatedLabel: "Not Rated",
      filterBy: "Filter By",
      byQuarter: "Quarter (3 Months)",
      selectQuarter: "Select a quarter...",
      notRatedSummary: "Not Rated",
      notRatedNote: "No ratings recorded",
      byDate: "Month",
      byChecklist: "Select Months",
      selectMonths: "Select months to include",
      noMonthsSelected: "Please select at least one month",
      monthsSelected: "months selected",
      ratedCountTitle: "Rated / Total",
      ratedCountNote: "Workers rated this period",
      notRatedCountTitle: "Not Rated / Total",
      notRatedCountNote: "Workers without a rating",
      avgRatingTitle: "Average Rating",
      belowTwoTitle: "Below 2.0",
      belowTwoAllTimeTitle: "Workers rated below 2.0",
      seeDetails: "See details",
      belowTwoModalTitle: "Workers rated below 2.0",
      noWorkersBelowTwo: "No workers below 2.0 right now.",
      leaderboardTitle: "Full Leaderboard",
      noRankedWorkers: "No rated workers for this period.",
      viewLeaderboard: "View Full Leaderboard",
      trendTitle: "Rating Trend",
      noTrendData: "No trend data yet",
      allTime: "All Time",
      ratingView: "Rating View",
      viewAll: "All Ratings",
      viewSupervisor: "Supervisor Ratings",
      viewOwn: "My Ratings",
      minRaters: "Minimum Raters",
      anyRaters: "Any",
      ratersLabel: "raters",
      trendMonthly : "3 Months",
      trendSixMonths : "6 Months",
      trendYearly : "Yearly",
      trendLoading : "Loading trend...",
      areaPerformance : "Performance by Area",
      areaPerformanceNote : "Average rating per work area for the selected period."
    },
    kpi: {
      workAreaCompliance: "Work Area Compliance",
      taskCompletion: "Task Completion",
      cleanliness: "Cleanliness",
      wasteManagement: "Waste Management",
      organization: "Organization",
      uniformCompliance: "Uniform Compliance",
      independence: "Independence",
      initiative: "Initiative",
      teamworkSupport: "Teamwork Support",
      punctuality: "Punctuality",
      attendance: "Attendance",
      leaveOnTime: "Leave Work On Time"
    },
    kpiShort: {
      workAreaCompliance: "WA",
      taskCompletion: "TC",
      cleanliness: "CL",
      wasteManagement: "WM",
      organization: "OR",
      uniformCompliance: "UC",
      independence: "IN",
      initiative: "IV",
      teamworkSupport: "TS",
      punctuality: "PU",
      attendance: "AT",
      leaveOnTime: "LT"
    },
    kpiRatingForm: {
      workAreaCompliance: "Work Area Compliance (WA)",
      taskCompletion: "Task Completion (TC)",
      cleanliness: "Cleanliness (CL)",
      wasteManagement: "Waste Management (WM)",
      organization: "Organization (OR)",
      uniformCompliance: "Uniform Compliance (UC)",
      independence: "Independence (IN)",
      initiative: "Initiative (IV)",
      teamworkSupport: "Teamwork Support (TS)",
      punctuality: "Punctuality (PU)",
      attendance: "Attendance (AT)",
      leaveOnTime: "Leave Work On Time (LT)"
    },
    kpiDescription: {
      workAreaCompliance: "Keeps their assigned work area organized, clean, and free of hazards throughout the shift.",
      taskCompletion: "Finishes assigned tasks fully and on time, without needing reminders or follow-up.",
      cleanliness: "Maintains high cleaning standards and attention to detail in the work performed.",
      wasteManagement: "Properly sorts, disposes of, and handles waste according to procedure.",
      organization: "Keeps tools, supplies, and materials arranged neatly and ready for use.",
      uniformCompliance: "Wears the required uniform and protective equipment correctly and consistently.",
      independence: "Carries out duties confidently without needing constant supervision.",
      initiative: "Identifies problems or extra tasks and acts on them without being asked.",
      teamworkSupport: "Cooperates with and supports colleagues to get shared work done.",
      punctuality: "Arrives and starts work on time for shifts and scheduled tasks.",
      attendance: "Shows up reliably for scheduled shifts with minimal unexcused absences.",
      leaveOnTime: "Leaves work according to scheduled working hours unless assigned overtime."
    },
    adminHome: {
      loading: "Loading dashboard...",
      loadError: "Failed to load dashboard data. Please try again.",
      title: "Admin Dashboard",
      subtitle: "System overview and account administration",
      totalUsers: "Total Users",
      supervisors: "Supervisors",
      workers: "Workers",
      admins: "Admins",
      avgWorkerRating: "Avg Worker Rating",
      recentAccounts: "Recent Accounts",
      noUsers: "No users found.",
      created: "Created",
      viewProfile: "View profile details",
      role_admin: "Admin",
      role_supervisor: "Supervisor",
      role_worker: "Worker"
    },
    adminUsers: {
      title: "Manage Users",
      subtitle: "Full control over accounts, roles, and access",
      addNewUser: "Add New User",
      userDirectory: "User Directory",
      searchPlaceholder: "Search by name or email...",
      loadingUsers: "Loading users...",
      noUsersMatch: "No users match your current filters.",
      confirmDelete: "Are you sure you want to delete this user?",
      confirmDeleteTitle: "Delete user",
      deleteFailed: "Failed to delete user",
      missingEmail: "This user needs an email before becoming a supervisor or admin.",
      missingUsername: "This user needs a username before becoming a worker.",
      invalidArea: "The selected worker area is invalid.",
      workerAreaOnly: "Areas can only be assigned to workers.",
      passwordUpdateFailed: "Failed to update password",
      resetPasswordTitle: "Reset User Password",
      resetPasswordLabel: "Enter new password for this user",
      newPasswordPlaceholder: "New password",
      updating: "Updating...",
      updatePassword: "Update Password",
      creating: "Creating...",
      createUser: "Create User",
      actions: "Actions",
      reset: "Reset",
      delete: "Delete",
      resetPassword: "Reset password",
      deleteUser: "Delete user",
      filterAll: "All",
      filterWorkers: "Workers",
      filterSupervisors: "Supervisors",
      filterAdmins: "Admins",
      roleWorker: "Worker",
      roleSupervisor: "Supervisor",
      roleAdmin: "Admin",
      roleUpdateFailed: "Failed to update role",
      area: "Area",
      unassigned: "Unassigned",
      areaUpdateFailed: "Failed to update worker area"
    },
    adminDataTools: {
      title: "Data Tools",
      subtitle: "Import and export system data (Excel)",
      exportData: "Export Data",
      selectedMonth: "Selected Month",
      overall: "Overall (All Ratings)",
      exporting: "Exporting...",
      downloadExcel: "Download Excel",
      importData: "Import Data",
      importing: "Importing...",
      uploadExcel: "Upload Excel",
      downloadTemplate: "Download Template",
      selectFileAlert: "Please select a file",
      importSuccess: "Import successful",
      importFailed: "Import failed"
    },
    adminApprovals: {
      title: "Worker Approvals",
      subtitle: "Review and approve new worker registrations",
      loading: "Loading pending approvals...",
      noPending: "No pending worker approvals at this time.",
      registeredAt: "Registered At",
      action: "Action",
      processing: "Processing...",
      approve: "Approve",
      reject: "Reject",
      loadFailed: "Failed to load pending approvals",
      approveFailed: "Failed to approve worker",
      rejectFailed: "Failed to reject worker"
    },
    adminEditRequests: {
      title: "Approvals & Requests",
      subtitle: "Manage worker registrations and rating edit requests",
      loading: "Loading data...",
      workerApprovalsTitle: "Worker Approvals",
      noWorkerApprovals: "No pending worker approvals.",
      ratingEditRequestsTitle: "Rating Edit Requests",
      noEditRequests: "No pending edit requests.",
      name: "Name",
      email: "Email",
      registeredAt: "Registered At",
      action: "Action",
      month: "Month",
      requestedAt: "Requested At",
      reason: "Reason",
      rater: "Worker (Rater)",
      ratedUser: "Rated User",
      processing: "Processing...",
      approve: "Approve",
      reject: "Reject",
      lateSubmissionRequestsTitle: "Late Submission Requests",
      noLateSubmissionRequests: "No pending late submission requests."
    },
    adminNav: {
      home: "Home",
      manageUsers: "Manage Users",
      dataVisuals: "Data Visuals",
      dataTools: "Data Tools",
      editRequests: "Edit Requests",
      profile: "Profile",
      logout: "Logout",
      expand: "Expand",
      collapse: "Collapse",
      schedule: "Work Schedule"
    },
    workerInformation: {
      loadingProfile: "Loading worker profile...",
      workerNotFound: "Worker not found",
      goBack: "Go back",
      back: "Back",
      workers: "Workers",

      avg: "avg",

      totalSessions: "Total Sessions",
      averageScore: "Average Score",
      performance: "Performance",

      ratingHistory: "Rating History",
      month: "month",
      months: "months",

      noRatingsRecorded: "No ratings recorded yet.",

      supervisor: "Supervisor",
      peer: "Peer",
      unknown: "Unknown",
      ratedBy: "Rated by",
      worker: "Worker",
      filterByRater: "Filter by rater",
      allRaters: "All raters",
      filterByMonth: "Filter by month",
      allMonths: "All months",
      clearFilters: "Clear",
      noRatingsMatchFilters: "No ratings match the selected filters."
    },
    ratingStatus: {
      noRatings: "No ratings yet",
      excellent: "Excellent",
      good: "Good",
      average: "Average",
      needsImprovement: "Needs Improvement"
    }
  },
  id: {
    common: {
      language: "Bahasa",
      english: "Inggris",
      indonesian: "Indonesia",
      loading: "Memuat...",
      fullName: "Nama Lengkap",
      email: "Alamat Email",
      role: "Peran Akun",
      saveChanges: "Simpan Perubahan",
      cancel: "Batal",
      logout: "Keluar",
      editProfile: "Edit Profil",
      username: "Nama Pengguna",
      optional: "Opsional",
      name : "Nama Lengkap",
      close: "Tutup",
      error: "Terjadi kesalahan",
      area: "Area",
      allAreas: "Semua area",
      unassigned: "Belum ditugaskan"
    },
    login: {
      createAccount: "Buat Akun",
      registerAsWorker: "Daftar sebagai pekerja",
      signUp: "Daftar",
      signingUp: "Mendaftar...",
      signIn: "Masuk",
      signingIn: "Masuk...",
      systemName: "Sistem Penilaian Kinerja Cleaning Service",
      needAccount: "Belum punya akun? Daftar",
      haveAccount: "Sudah punya akun? Masuk",
      welcomeBack: "Selamat Datang Kembali!",
      haveAccountOverlay: "Sudah punya akun? Masuk dengan kredensial Anda.",
      helloWorker: "Halo, Pekerja!",
      noAccountOverlay: "Belum punya akun? Daftar dan bergabung dengan tim Anda!",
      registrationSuccess: "Pendaftaran berhasil! Menunggu persetujuan admin...",
      loginFailed: "Gagal masuk",
      registrationFailed: "Pendaftaran gagal",
      password: "Kata Sandi",
      emailOrUsername: "Email atau Nama Pengguna"
    },
    profile: {
      title: "Profil Saya",
      subtitle: "Lihat dan kelola pengaturan akun Anda",
      accountInfo: "Informasi Akun",
      statistics: "Statistik",
      preferences: "Preferensi",
      accountCreated: "Akun Dibuat",
      avgRating: "Rata-rata Nilai",
      totalRatingsReceived: "Total Penilaian Diterima",
      totalRatingsGiven: "Total Penilaian Diberikan",
      totalRatings: "Total Penilaian",
      accountId: "ID Akun",
      notAvailable: "Tidak tersedia",
      receiveEmail: "Terima notifikasi email",
      receiveEmailWorkerDesc: "Dapatkan notifikasi tentang penilaian, umpan balik, dan pembaruan",
      receiveEmailSupervisorDesc: "Dapatkan notifikasi tentang pembaruan pekerja dan sistem",
      showTipsWorker: "Tampilkan tips dashboard",
      showTipsSupervisor: "Tampilkan tips dan saran",
      showTipsWorkerDesc: "Tampilkan tips yang membantu di dashboard pekerja",
      showTipsSupervisorDesc: "Tampilkan tips yang membantu saat menggunakan dashboard",
      showTipsAdmin: "Tampilkan tips dashboard admin",
      updatedSuccess: "Profil berhasil diperbarui.",
      updateFailed: "Gagal memperbarui profil.",
      logoutTitle: "Keluar",
      logoutConfirm: "Apakah Anda yakin ingin keluar?",
      changePhoto:"Ganti Foto Profil",
      fileTooLarge: "Ukuran foto terlalu besar!",
      invalidFileType: "Jenis file tidak valid. Silakan unggah gambar.",
      pictureUpdatedSuccess: "Foto profil berhasil diperbarui.",
      pictureUploadFailed: "Gagal mengunggah foto profil."
    },
    workerHome: {
      loading: "Memuat...",
      title: "Dashboard",
      welcomeBack: "Selamat datang kembali,",
      avgRating: "Rata-rata Nilai",
      totalReviews: "Total Ulasan",
      updated7Days: "Diperbarui dalam 7 Hari Terakhir",
      recentRatings: "Penilaian Terbaru Diterima",
      supervisor: "Supervisor",
      peer: "Rekan",
      teamLead: "Ketua Tim",
      anonymousColleague: "Rekan Anonim",
      supervisorRating: "Penilaian supervisor",
      peerRating: "Penilaian rekan",
      noRatings: "Belum ada penilaian. Cek kembali nanti untuk umpan balik dari supervisor.",
      totalRatings: "Total Penilaian",
      needsAttention: "Perlu Perhatian",
      legendTitle: "Singkatan Kolom Penilaian",
      hide: "Sembunyikan",
      show: "Tampilkan",
      monthlyHistory: "Riwayat Penilaian Bulanan",
      ratingsSuffix: "penilaian",
      ratingSuffix: "penilaian",
      overallRating: "Nilai Keseluruhan",
      cumulativeRanking: "Peringkat Kumulatif Anda",
      notRanked: "Belum masuk peringkat",
      noMonthlyHistory: "Belum ada riwayat bulanan.",
      avgShort: "rata-rata",
      overview: "Ringkasan Performa Anda"
    },
    schedule: {
      title: "Jadwal Kerja",
      subtitle: "Jadwal kebersihan harian per area",
      myArea: "Area Saya",
      myAreaBadge: "Area Anda",
      wholeSchedule: "Seluruh Jadwal",
      filterLabel: "Filter jadwal",
      sections: "Bagian",
      now: "Sekarang",
      expand: "Perbesar",
      closeExpanded: "Tutup",
      noAreaAssigned: "Anda belum ditugaskan ke area mana pun, jadi seluruh jadwal ditampilkan.",
      empty: "Tidak ada jadwal untuk area ini.",
      note: "Pekerjaan sifatnya tidak mengikat. Jika dibutuhkan untuk pekerjaan lain, dapat menyesuaikan sesuai arahan pengawas"
    },
    workerRatings: {
      modalTitle: "Minta Edit Penilaian",
      modalReasonLabel: "Kenapa Anda perlu mengedit penilaian ini?",
      modalReasonPlaceholder: "Berikan alasan untuk permintaan edit...",
      lateSubmissionModalTitle: "Minta Izin Pengiriman Terlambat",
      lateSubmissionReasonLabel: "Kenapa Anda perlu meminta izin pengiriman terlambat?",
      lateSubmissionReasonPlaceholder: "Berikan alasan untuk permintaan pengiriman terlambat...",
      submitting: "Mengirim...",
      submitRequest: "Kirim Permintaan",
      rateColleaguesTitle: "Nilai Rekan",
      rateColleaguesSubtitle: "Nilai rekan hanya untuk bulan yang sudah selesai",
      byMonth: "Berdasarkan bulan",
      apply: "Terapkan",
      visibleWorkers: "Pekerja Terlihat",
      ratedByYou: "Dinilai Oleh Anda",
      notYetRated: "Belum Dinilai",
      searchByName: "Cari berdasarkan nama...",
      all: "Semua",
      rated: "Sudah Dinilai",
      unrated: "Belum Dinilai",
      ratingMonth: "Bulan Penilaian",
      ratingUnavailable: "Penilaian tidak tersedia untuk",
      workersCanOnlyRate: "Pekerja hanya bisa menilai pada",
      loadingWorkers: "Memuat pekerja...",
      noWorkersSearch: "Tidak ada pekerja yang cocok dengan pencarian Anda.",
      noWorkersDisplay: "Tidak ada pekerja untuk ditampilkan.",
      tableName: "Nama",
      tableAvgRating: "Rata-rata Nilai",
      tableLatestRating: "Penilaian Terakhir",
      tableSelectedMonth: "Bulan Dipilih",
      tableLastComment: "Komentar Terakhir",
      avgShort: "rata-rata",
      lowShort: "rendah",
      selectedMonthTag: "bulan dipilih",
      noRatingsYet: "Belum ada penilaian",
      action: "Aksi",
      editPending: "Edit Menunggu",
      edit: "Edit",
      requestEdit: "Minta Edit",
      rate: "Nilai",
      askAdminUnlock: "Minta admin membuka kunci penilaian ini agar bisa diedit",
      dash: "-",
      tableIndex: "No.",
      pendingApproval: "Menunggu Persetujuan",
      requestPermission: "Minta Izin",
      activeFilterMonthPrefix: "Bulan:",
      clearFilter: "Hapus filter",
      myAverageRating: "Rata-rata Penilaian Saya Bulan Ini",
      legendTitle: "Status:",
      myCumulativeRating: "Rata-rata Kumulatif Saya",
      sessions: "Sesi",
      latestRating: "Penilaian Terakhir",
      myRatingThisMonth: "Penilaian Saya"
    },
    ratingForm: {
      commentLabel: "Komentar (Opsional)",
      commentPlaceholder: "Tambahkan komentar atau umpan balik...",
      submitting: "Mengirim...",
      updating: "Memperbarui...",
      submit: "Kirim Penilaian",
      update: "Perbarui Penilaian",
      rateTitle: "Nilai",
      overallAverage: "Nilai rata-rata",
      editTitle: "Edit Penilaian"
    },
    workerFeedback: {
      title: "Umpan Balik",
      subtitle: "Umpan balik dari supervisor dan rekan",
      byMonth: "Berdasarkan bulan",
      apply: "Terapkan",
      loadingFeedback: "Memuat umpan balik...",
      supervisorFeedback: "Umpan Balik Supervisor",
      peerFeedback: "Umpan Balik Rekan",
      noSupervisorFeedback: "Belum ada umpan balik supervisor dengan komentar.",
      noPeerFeedback: "Belum ada umpan balik rekan dengan komentar.",
      anonymousColleague: "Rekan Anonim",
      supervisorLabel: "Umpan Balik Supervisor",
      peerLabel: "Umpan Balik Rekan",
      ratingMonth: "Periode Masukan",
      allTime: "Sepanjang waktu",
      legendTitle: "Warna penilaian:",
      noRatings: "Belum ada penilaian",
      excellent: "Sangat Baik (≥ 3,51)",
      good: "Baik (2,76 - 3,50)",
      average: "Cukup (2,00 - 2,75)",
      needsImprovement: "Perlu Peningkatan (< 2,00)"
    },
    workerNav: {
      home: "Beranda",
      rateColleagues: "Nilai Rekan",
      feedback: "Umpan Balik",
      profile: "Profil",
      logout: "Keluar",
      expand: "Perluas",
      collapse: "Ciutkan",
      schedule: "Jadwal Kerja"
    },
    supervisorNav: {
      home: "Beranda",
      details: "Penilaian Kinerja",
      dataVisuals: "Monitoring Kerja",
      profile: "Profil",
      logout: "Keluar",
      expand: "Perluas",
      collapse: "Ciutkan",
      schedule: "Jadwal Kerja",
    },
    supervisorHome: {
      loading: "Memuat...",
      welcomeBack: "Selamat Datang Kembali!",
      overview: "Berikut ringkasan performa Anda",
      totalWorkers: "Jumlah CS",
      averageRating: "Rating Rata-rata",
      topPerformer: "Performa Terbaik",
      filterThisMonth: "Bulan Ini",
      filterCumulative: "Kumulatif",
      belowTwoTitle: "Pekerja di bawah 2.0",
      belowTwoLastMonth: "2.0 Bulan Lalu",
      seeDetails: "Lihat detail",
      noWorkersBelowTwo: "Tidak ada pekerja di bawah 2.0 saat ini.",
      recentRatings: "Penilaian Terbaru",
      noRatings: "Belum ada penilaian. Mulai menilai pekerja untuk melihat aktivitas terbaru.",
      workersRated: "Pekerja Dinilai",
      workersNotRated: "Pekerja Belum Dinilai",
      updated7Days: "Diperbarui dalam 7 Hari Terakhir",
      belowThree: "Rata-rata Di Bawah 3.0",
      legendTitle: "Singkatan Bidang Penilaian",
      hide: "Sembunyikan",
      show: "Tampilkan",
      notAvailable: "T/A",
      highest: "Tertinggi",
      average: "Rata-rata",
      weakest: "Terlemah",
      lowRatingHistory: "Bulan di bawah 2.0",
      filterLastMonth: "Bulan Lalu",
      overviewMonth: "Berikut adalah ringkasan Penilian Anda untuk",
      overviewCumulative: "Berikut adalah ringkasan Penilian kinerja kumulatif Anda."
    },
    supervisorRatings: {
      title: "Detail dan Penilaian Pekerja",
      subtitle: "Nilai pekerja hanya untuk bulan yang sudah selesai",
      byMonth: "Berdasarkan bulan",
      apply: "Terapkan",
      visibleWorkers: "Total CS",
      ratedInMonth: "Dinilai di Bulan Ini",
      notYetRated: "Belum Dinilai",
      searchPlaceholder: "Cari berdasarkan nama atau email...",
      sort: "Urutkan",
      sortName: "Nama (A-Z)",
      sortRating: "Nilai Tertinggi",
      sortRecent: "Aktivitas Terbaru",
      all: "Semua",
      rated: "Sudah Dinilai",
      unrated: "Belum Dinilai",
      viewingMonth: "Bulan Dilihat",
      ratingUnavailable: "Penilaian tidak tersedia untuk",
      onlyAvailableIn: "Penilaian hanya tersedia pada",
      loadingWorkers: "Memuat pekerja...",
      noWorkersSearch: "Tidak ada pekerja yang cocok dengan pencarian Anda.",
      noWorkersDisplay: "Tidak ada pekerja untuk ditampilkan.",
      name: "Nama",
      email: "Email",
      sessions: "Sesi",
      status: "Status",
      latestRating: "Penilaian Terakhir Saya",
      selectedMonth: "Bulan Dipilih",
      lastComment: "Komentar Terakhir",
      selectedMonthTag: "bulan dipilih",
      noRatingsYet: "Belum ada penilaian",
      action: "Aksi",
      edit: "Edit",
      rate: "Nilai",
      dash: "-",
      avgShort: "rata-rata",
      lowShort: "rendah",
      avgRating: "Rata-Rata Kumulatif Saya",      
      statusCumulative: "Status Kumulatif",
      periodActive: "Periode Aktif",
      detail : "Detail",
      myRatingThisMonth: "Penilaian Saya",
      legendTitle : "Status :",
      myAverageRating	: "Rata-Rata Penilaian Saya Bulan Ini"
    },
    supervisorVisuals: {
      loading: "Memuat analitik...",
      title: "Monitoring Kerja dan Analitik",
      subtitle: "Metrik performa dan insight",
      byMonth: "Berdasarkan bulan",
      apply: "Terapkan",
      filterNote: "Menampilkan pekerja dengan bulan penilaian terbaru sesuai bulan yang dipilih.",
      overallAverage: "Rata-rata Nilai Keseluruhan",
      basedOnWorkers: "Berdasarkan {count} pekerja",
      totalWorkersEvaluated: "Total CS Dievaluasi",
      activeInSystem: "Aktif di sistem",
      excellentPerformers: "Performa Sangat Baik",
      ratingThreeFour: "Nilai 3.5+",
      noDataFilter: "Tidak ada data yang cocok dengan filter terpilih.",
      ratingDistribution: "Distribusi Penilaian",
      pieTitle: "Diagram Lingkaran Distribusi",
      workers: "pekerja",
      topPerformers: "Top 6 Performa Terbaik",
      ratings: "penilaian",
      kpiAverages: "Rata-rata KPI Performa",
      kpiNote: "Berdasarkan pekerja dengan penilaian bulanan yang sudah dikirim: {count}",
      excellentLabel: "Sangat Baik (3.51-4.00)",
      goodLabel: "Baik (2.76-3.50)",
      averageLabel: "Cukup (2.00-2.75)",
      poorLabel: "Kurang (<2.00)",
      notRatedLabel: "Belum Dinilai",
      filterBy: "Filter Berdasarkan",
      byQuarter: "Kuartal (3 Bulan)",
      selectQuarter: "Pilih kuartal...",
      notRatedSummary: "Belum Dinilai",
      notRatedNote: "Tidak ada penilaian tercatat",
      byDate:"Bulan",
      byChecklist: "Pilih Bulan",
      selectMonths: "Pilih bulan yang ingin disertakan",
      noMonthsSelected: "Silakan pilih minimal satu bulan",
      monthsSelected: "bulan dipilih",
      ratedCountTitle: "Dinilai / Total",
      ratedCountNote: "Pekerja yang dinilai periode ini",
      notRatedCountTitle: "Belum Dinilai / Total",
      notRatedCountNote: "Pekerja tanpa rating",
      avgRatingTitle: "Rata-Rata Rating",
      belowTwoTitle: "Di Bawah 2.0",
      belowTwoAllTimeTitle: "Pekerja dengan rating di bawah 2.0",
      seeDetails: "Lihat detail",
      belowTwoModalTitle: "Pekerja pada atau di bawah 2.0",
      noWorkersBelowTwo: "Belum ada pekerja di bawah 2.0 saat ini.",
      leaderboardTitle: "Papan Peringkat Lengkap",
      noRankedWorkers: "Belum ada pekerja yang dinilai untuk periode ini.",
      viewLeaderboard: "Lihat Papan Peringkat Lengkap",
      trendTitle: "Tren Rating",
      noTrendData: "Belum ada data tren",
      allTime: "Sepanjang Waktu",
      ratingView: "Tampilan Rating",
      viewAll: "Semua Rating",
      viewSupervisor: "Rating Supervisor",
      viewOwn: "Rating Saya",
      minRaters: "Jumlah Penilai Minimum",
      anyRaters: "Semua",
      ratersLabel: "penilai",
      trendMonthly: "3 Bulan",
      trendSixMonths: "6 Bulan",
      trendYearly: "Tahunan",
      trendLoading: "Memuat tren...",
      areaPerformance: "Kinerja per Area",
      areaPerformanceNote: "Rata-rata penilaian per area kerja untuk periode yang dipilih."
    },
    kpi: {
      workAreaCompliance: "Kepatuhan Area Kerja",
      taskCompletion: "Kualitas & Standar Kerja",
      cleanliness: "Kebersihan Area",
      wasteManagement: "Pengelolaan Sampah",
      organization: "Kerapian & Estetika Area",
      uniformCompliance: "Kedislipinan Seragam & APD",
      independence: "Kemandirian Kerja",
      initiative: "Inisiatif & Responsivitas",
      teamworkSupport: "Kerja Sama & Fleksibilitas",
      punctuality: "Ketepatan Waktu",
      attendance: "Kepatuhan Jam Kerja",
      leaveOnTime: "Kehadiran & Komitmen"
    },
    kpiShort: {
      workAreaCompliance: "KAK",
      taskCompletion: "KSK",
      cleanliness: "KBA",
      wasteManagement: "PSA",
      organization: "KEA",
      uniformCompliance: "KSA",
      independence: "KDK",
      initiative: "IR",
      teamworkSupport: "KSF",
      punctuality: "KTW",
      attendance: "KJK",
      leaveOnTime: "KHK"
    },
    kpiRatingForm: {
      workAreaCompliance: "Kepatuhan Area Kerja (KAK)",
      taskCompletion: "Kualitas & Standar Kerja (KSK)",
      cleanliness: "Kebersihan Area (KBA)",
      wasteManagement: "Pengelolaan Sampah (PSA)",
      organization: "Kerapian & Estetika Area (KEA)",
      uniformCompliance: "Kedislipinan Seragam & APD (KSA)",
      independence: "Kemandirian Kerja (KDK)",
      initiative: "Inisiatif & Responsivitas (IR)",
      teamworkSupport: "Kerja Sama & Fleksibilitas (KSF)",
      punctuality: "Ketepatan Waktu (KTW)",
      attendance: "Kepatuhan Jam Kerja (KJK)",
      leaveOnTime: "Kehadiran & Komitmen (KHK)"
    },
    kpiDescription: {
      workAreaCompliance: "Melaksanakan pekerjaan sesuai area yang ditentukan",
      taskCompletion: "Menyelesaikan tugas sesuai standar kerja",
      cleanliness: "Area tanggung jawab bebas debu dan noda",
      wasteManagement: "Sampah dibuang dan dikelola dengan benar",
      organization: "Area tanggung jawab tertata dan enak dipandang",
      uniformCompliance: "Menggunakan seragam kerja / APD dengan rapi",
      independence: "Bekerja tanpa harus selalu diarahkan",
      initiative: "Tanggap melihat area kotor tanpa disuruh",
      teamworkSupport: "Bersedia membantu area lain bila dibutuhkan",
      punctuality: "Hadir tepat waktu sesuai jadwal",
      leaveOnTime: "Pulang sesuai jam kerja / tidak meninggalkan kerja tanpa izin",
      attendance: "Tingkat kehadiran (jarang absen / izin)"
    },
    adminHome: {
      loading: "Memuat dashboard...",
      loadError: "Gagal memuat data dashboard. Silakan coba lagi.",
      title: "Dashboard Admin",
      subtitle: "Ringkasan sistem dan administrasi akun",
      totalUsers: "Total Pengguna",
      supervisors: "Supervisor",
      workers: "Pekerja",
      admins: "Admin",
      avgWorkerRating: "Rata-rata Nilai Pekerja",
      recentAccounts: "Akun Terbaru",
      noUsers: "Tidak ada pengguna ditemukan.",
      created: "Dibuat",
      viewProfile: "Lihat detail profil",
      role_admin: "Admin",
      role_supervisor: "Supervisor",
      role_worker: "Pekerja"
    },
    adminUsers: {
      title: "Kelola Pengguna",
      subtitle: "Kontrol penuh atas akun, peran, dan akses",
      addNewUser: "Tambah Pengguna Baru",
      userDirectory: "Direktori Pengguna",
      searchPlaceholder: "Cari berdasarkan nama atau email...",
      loadingUsers: "Memuat pengguna...",
      noUsersMatch: "Tidak ada pengguna yang cocok dengan filter Anda.",
      confirmDelete: "Apakah Anda yakin ingin menghapus pengguna ini?",
      confirmDeleteTitle: "Hapus pengguna",
      deleteFailed: "Gagal menghapus pengguna",
      missingEmail: "Pengguna ini memerlukan email sebelum menjadi supervisor atau admin.",
      missingUsername: "Pengguna ini memerlukan nama pengguna sebelum menjadi pekerja.",
      invalidArea: "Area pekerja yang dipilih tidak valid.",
      workerAreaOnly: "Area hanya dapat ditetapkan kepada pekerja.",
      passwordUpdateFailed: "Gagal memperbarui kata sandi",
      resetPasswordTitle: "Reset Kata Sandi Pengguna",
      resetPasswordLabel: "Masukkan kata sandi baru untuk pengguna ini",
      newPasswordPlaceholder: "Kata sandi baru",
      updating: "Memperbarui...",
      updatePassword: "Perbarui Kata Sandi",
      creating: "Membuat...",
      createUser: "Buat Pengguna",
      actions: "Aksi",
      reset: "Reset",
      delete: "Hapus",
      resetPassword: "Reset kata sandi",
      deleteUser: "Hapus pengguna",
      filterAll: "Semua",
      filterWorkers: "Pekerja",
      filterSupervisors: "Supervisor",
      filterAdmins: "Admin",
      roleWorker: "Pekerja",
      roleSupervisor: "Supervisor",
      roleAdmin: "Admin",
      roleUpdateFailed: "Gagal memperbarui peran",
      area: "Area",
      unassigned: "Belum ditetapkan",
      areaUpdateFailed: "Gagal memperbarui area pekerja"
    },
    adminDataTools: {
      title: "Alat Data",
      subtitle: "Impor dan ekspor data sistem (Excel)",
      exportData: "Ekspor Data",
      selectedMonth: "Bulan Dipilih",
      overall: "Keseluruhan (Semua Penilaian)",
      exporting: "Mengekspor...",
      downloadExcel: "Unduh Excel",
      importData: "Impor Data",
      importing: "Mengimpor...",
      uploadExcel: "Unggah Excel",
      downloadTemplate: "Unduh Template",
      selectFileAlert: "Silakan pilih file",
      importSuccess: "Impor berhasil",
      importFailed: "Impor gagal"
    },
    adminApprovals: {
      title: "Persetujuan Pekerja",
      subtitle: "Tinjau dan setujui pendaftaran pekerja baru",
      loading: "Memuat persetujuan yang tertunda...",
      noPending: "Tidak ada persetujuan pekerja yang tertunda saat ini.",
      registeredAt: "Terdaftar Pada",
      action: "Aksi",
      processing: "Memproses...",
      approve: "Setujui",
      reject: "Tolak",
      loadFailed: "Gagal memuat persetujuan yang tertunda",
      approveFailed: "Gagal menyetujui pekerja",
      rejectFailed: "Gagal menolak pekerja"
    },
    adminEditRequests: {
      title: "Persetujuan & Permintaan",
      subtitle: "Kelola pendaftaran pekerja dan permintaan edit penilaian",
      loading: "Memuat data...",
      workerApprovalsTitle: "Persetujuan Pekerja",
      noWorkerApprovals: "Tidak ada persetujuan pekerja yang tertunda.",
      ratingEditRequestsTitle: "Permintaan Edit Penilaian",
      noEditRequests: "Tidak ada permintaan edit yang tertunda.",
      name: "Nama",
      email: "Email",
      registeredAt: "Terdaftar Pada",
      action: "Aksi",
      month: "Bulan",
      requestedAt: "Diminta Pada",
      reason: "Alasan",
      rater: "Pekerja (Penilai)",
      ratedUser: "Pengguna Dinilai",
      processing: "Memproses...",
      approve: "Setujui",
      reject: "Tolak",
      lateSubmissionRequestsTitle: "Permintaan Pengiriman Terlambat",
      noLateSubmissionRequests: "Tidak ada permintaan pengiriman terlambat."
    },
    adminNav: {
      home: "Beranda",
      manageUsers: "Kelola Pengguna",
      dataVisuals: "Monitoring Kerja",
      dataTools: "Alat Data",
      editRequests: "Permintaan Edit",
      profile: "Profil",
      logout: "Keluar",
      expand: "Perluas",
      collapse: "Ciutkan",
      schedule: "Jadwal Kerja"
    },
    workerInformation: {
      loadingProfile: "Memuat profil pekerja...",
      workerNotFound: "Pekerja tidak ditemukan",
      goBack: "Kembali",
      back: "Kembali",
      workers: "Pekerja",

      avg: "rata-rata",

      totalSessions: "Total Sesi",
      averageScore: "Rata-rata Nilai",
      performance: "Performa",

      ratingHistory: "Riwayat Penilaian",
      month: "bulan",
      months: "bulan",

      noRatingsRecorded: "Belum ada penilaian yang tercatat.",

      supervisor: "Supervisor",
      peer: "Rekan Kerja",
      unknown: "Tidak Diketahui",
      ratedBy: "Dinilai oleh",
      worker: "Pekerja",
      filterByRater: "Filter berdasarkan penilai",
      allRaters: "Semua penilai",
      filterByMonth: "Filter berdasarkan bulan",
      allMonths: "Semua bulan",
      clearFilters: "Hapus filter",
      noRatingsMatchFilters: "Tidak ada penilaian yang sesuai dengan filter yang dipilih."
    },
    ratingStatus: {
      noRatings: "Belum ada penilaian",
      excellent: "Sangat Baik",
      good: "Baik",
      average: "Cukup",
      needsImprovement: "Kurang"
    }
  }
};